import { useProjectContext } from "@contexts/projects";
import IndicatorCard from "./IndicatorCard";
import { cardTexts } from "@utils/cardTexts";
import { checkIfMultipleIds } from "@utils/checkMultipleIds";
import { useAuthContext } from "@contexts/auth";
import { usePlanBasis } from "@utils/planBasis";
import { sumCommitted } from "@utils/committedTotal";
import { Fragment } from "react";

const Indicators = () => {
  const { activeProject: { indicator, committedTotal, attended_total }, activeProject } = useProjectContext();
  const { user: { configurations: { dashboard: { cards: { graph } } } } } = useAuthContext();
  const { basis, idpValue } = usePlanBasis();
  const idpTooltip = basis === 'forecast' ? cardTexts.IDP_FORECAST : basis === 'base' ? cardTexts.IDP : cardTexts.IDP_NO_PLAN;
  const scheduleSource = activeProject?.scheduleSource;
  const sourceLabel = scheduleSource?.source === "prevision" ? "Prevision"
    : scheduleSource?.source === "sienge" ? "Sienge"
      : scheduleSource?.source === "mega" ? "MEGA" : null;
  const conditionLabel = scheduleSource?.condition === "fallback_last_valid"
    ? ", último snapshot válido"
    : scheduleSource?.condition === "fallback_erp"
      ? ", fallback ERP"
      : "";
  const sourceSuffix = sourceLabel ? ` (curvas: ${sourceLabel}${conditionLabel})` : "";

  const checkCard = (i) => {
    switch (i) {
      case 'indexTrend':
        return <IndicatorCard
          title="Orçado Indexado/ Tendência"
          tooltip={cardTexts.TREND_BUDGETED}
          reasonId="metric-indexed-budget-trend-reason"
          envelope={activeProject.metrics?.ioit}
        />
      case 'idc':
        if (checkIfMultipleIds()) return
        return <IndicatorCard title="IDC" tooltip={cardTexts.IDC} envelope={activeProject.metrics?.idc} />
      case 'apropriated':
        if (checkIfMultipleIds()) return
        return <IndicatorCard title="Pagamentos apropriados" tooltip={cardTexts.APPROPRIATED} black indicator={indicator?.ipa} />
      case 'idp':
        if (checkIfMultipleIds()) return
        return <IndicatorCard title="IDP" tooltip={idpTooltip + sourceSuffix} indicator={idpValue} />
      case 'apr_compr': {
        if (checkIfMultipleIds()) return
        // `committedTotal[0].value` sem optional chaining estourava TypeError em obra
        // sem comprometido; e mesmo com dado usava só a primeira raiz. Denominador
        // zero vira `null` para o card exibir "—" em vez de Infinity/NaN.
        const committedTotalValue = sumCommitted(committedTotal);
        return <IndicatorCard title="Pagamentos apropriados / Comprometido" tooltip={cardTexts.APR_COMPR} black indicator={committedTotalValue ? attended_total / committedTotalValue : null} />
      }
      default:
        break;
    }
  }

  return (
    <div>
      <div className="grid columns-3 columns-1-laptop gap-16">
        {graph.map(i => {
          return <Fragment key={i}>{checkCard(i)}</Fragment>
        })}
      </div>
    </div>
  )
}

export default Indicators;
